import { TYPES } from "./default_hacker.type";
import {
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const app = getApp();
const auth = getAuth(app);

// ========= firebase function =========//

//snap all provider
const allDefaultHackerSub = [];
export const snapDefaultHacker = (callback) => (dispatch) => {
  setDefaultHackerAllSuccess(dispatch, null);
  const cRef = getRefs().hacker;
  const uid = auth?.currentUser?.uid;
  const c1 = where("owner", "==", uid);
  const c2 = where("source", "==", "client");
  const qRef = query(cRef, c1, c2);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      setDefaultHackerAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allDefaultHackerSub.push(unsub);
};

export const unSnapDefaultHacker = () => (dispatch) => {
  allDefaultHackerSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultHackerSub.length = 0;
};
// ========= cloud function =========//
// ========= local function =========//
export const setDefaultHackerAll = (data, callback) => (dispatch) => {
  setDefaultHackerAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultHackerAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_HACKER_ALL,
    payload: data,
  });
};
